import React, { useContext } from "react";
import { PetCard } from "../PetCard";
import { PetsContext } from "../PetsProvider";
import { FilterContext } from "../FilterProvider";

export const PetList = () => {
  const { pets } = useContext(PetsContext);
  const { filterValue } = useContext(FilterContext);

  const petList = filterValue
    ? pets.filter((p) => p.petType === filterValue)
    : pets;

  return (
    <ul className="pet-list">
      {petList.map((filteredPet, index) => (
        <li key={filteredPet.name}>
          <PetCard pet={filteredPet} petList={petList} position={index} />
        </li>
      ))}
    </ul>
  );
};
